import { createExchangeTokenRedirect } from '../../../admin-portal/src/services/exchangeTokenService.js'
import { TARGET_APPS } from '../../enums/target-apps.js'
import { showSnackbar } from '../../state/snackbar.js'
import { loadingSpinner } from '../../state/loading-spinner.js'

export const CONSENT_CONFIG_TARGET_APP = TARGET_APPS.CONSENT_CONFIG
export const EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE = 'Error authenticating portal access. Please try again later.'

export async function getConsentConfigApiRedirectUrl () {
	const redirectUrl = await createExchangeTokenRedirect(TARGET_APPS.CONSENT_CONFIG)
	if (!redirectUrl) {
		console.error('[consent-configuration-api-navigation] exchange token redirect unavailable')
		showSnackbar({ text: EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE, color: 'red' })
		return null
	}
	return redirectUrl
}

export async function navigateToConsentConfigurationApiPortal () {
	const redirectUrl = await getConsentConfigApiRedirectUrl()
	if (!redirectUrl) {
		loadingSpinner.value = false
		return false
	}
	loadingSpinner.value = true
	window.location.href = redirectUrl
	return true
}
